import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  rankList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
  },
  iconTimer: {
    marginRight: 4,
    padding: 4,
    borderRadius: "50%",
    background: theme.colors.border1,
  },
  divider: {
    height: 1,
    background: theme.colors.border1,
  },
  howToWin: {
    paddingTop: theme.spacing.space20,
    paddingBottom: theme.spacing.space8,
  },
}));
